export const mapCommonFile = (_, baseFile) => ({
  ...baseFile,
  fileInput: null,
  fileOutput: null,
  videoPreviewUrls: null
});
//# sourceMappingURL=CommonFile.mappers.js.map